"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOPICS_SET = exports.TOPICS_CLEAR = exports.SEARCH_SUGGESTIONS_SET_ACTIVE = exports.SEARCH_SUGGESTIONS_SET = exports.SEARCH_SUGGESTIONS_CLEAR = exports.SEARCH_RESULTS_SET = exports.SEARCH_RESULTS_CLEAR = exports.ARTICLE_SET = exports.ARTICLE_CLEAR = exports.APP_TOPIC_ID_SET = exports.APP_TOPIC_ID_CLEAR = exports.APP_QUERY_SET = exports.APP_MARKET_SET = exports.APP_LOADING_SET = exports.APP_HISTORY_INDEX_SET = exports.APP_HISTORY_ENTRIES_SET = exports.APP_ERROR_SET = exports.APP_ENV_SET = exports.APP_CLEAR = void 0;
var APP_CLEAR = 'APP_CLEAR';
exports.APP_CLEAR = APP_CLEAR;
var APP_ENV_SET = 'APP_ENV_SET';
exports.APP_ENV_SET = APP_ENV_SET;
var APP_ERROR_SET = 'APP_ERROR_SET';
exports.APP_ERROR_SET = APP_ERROR_SET;
var APP_HISTORY_ENTRIES_SET = 'APP_HISTORY_ENTRIES_SET';
exports.APP_HISTORY_ENTRIES_SET = APP_HISTORY_ENTRIES_SET;
var APP_HISTORY_INDEX_SET = 'APP_HISTORY_INDEX_SET';
exports.APP_HISTORY_INDEX_SET = APP_HISTORY_INDEX_SET;
var APP_LOADING_SET = 'APP_LOADING_SET';
exports.APP_LOADING_SET = APP_LOADING_SET;
var APP_MARKET_SET = 'APP_MARKET_SET';
exports.APP_MARKET_SET = APP_MARKET_SET;
var APP_QUERY_SET = 'APP_QUERY_SET';
exports.APP_QUERY_SET = APP_QUERY_SET;
var APP_TOPIC_ID_CLEAR = 'APP_TOPIC_ID_CLEAR';
exports.APP_TOPIC_ID_CLEAR = APP_TOPIC_ID_CLEAR;
var APP_TOPIC_ID_SET = 'APP_TOPIC_ID_SET';
exports.APP_TOPIC_ID_SET = APP_TOPIC_ID_SET;
var ARTICLE_CLEAR = 'ARTICLE_CLEAR';
exports.ARTICLE_CLEAR = ARTICLE_CLEAR;
var ARTICLE_SET = 'ARTICLE_SET';
exports.ARTICLE_SET = ARTICLE_SET;
var SEARCH_RESULTS_CLEAR = 'SEARCH_RESULTS_CLEAR';
exports.SEARCH_RESULTS_CLEAR = SEARCH_RESULTS_CLEAR;
var SEARCH_RESULTS_SET = 'SEARCH_RESULTS_SET';
exports.SEARCH_RESULTS_SET = SEARCH_RESULTS_SET;
var SEARCH_SUGGESTIONS_CLEAR = 'SEARCH_SUGGESTIONS_CLEAR';
exports.SEARCH_SUGGESTIONS_CLEAR = SEARCH_SUGGESTIONS_CLEAR;
var SEARCH_SUGGESTIONS_SET = 'SEARCH_SUGGESTIONS_SET';
exports.SEARCH_SUGGESTIONS_SET = SEARCH_SUGGESTIONS_SET;
var SEARCH_SUGGESTIONS_SET_ACTIVE = 'SEARCH_SUGGESTIONS_SET_ACTIVE';
exports.SEARCH_SUGGESTIONS_SET_ACTIVE = SEARCH_SUGGESTIONS_SET_ACTIVE;
var TOPICS_CLEAR = 'TOPICS_CLEAR';
exports.TOPICS_CLEAR = TOPICS_CLEAR;
var TOPICS_SET = 'TOPICS_SET';
exports.TOPICS_SET = TOPICS_SET;